class ExplorerHistory {

    constructor(component, data, route, pageYOffset, title, thumbnail = null) {
        this.component = component;
        this.data = data;
        this.route = route;
        this.pageYOffset = pageYOffset;
        this.title = title;
        this.langSensitive = false;
        this.setThumbnail(thumbnail);
    }

    getComponent() {
        return this.component;
    }

    getData() {
        return this.data;
    }

    getRoute() {
        return this.route;
    }


    getPageYOffset() {
        return this.pageYOffset;
    }

    getThumbnail() {
        return this.thumbnail;
    }

    setThumbnail(thumbnail) {
        this.thumbnail = thumbnail;
    }

    setLangSensitivity(value) {
        this.langSensitive = value;
    }

    getTitle() {
        return this.title;
    }

    isLangSensitive() {
        return this.langSensitive;
    }

    static resolve(context) {
        return new Promise(resolve => {
            const historyItem = context.$store.getters["explorerStore/history"].find(item => item.getComponent() === context.$options.name);
            if (historyItem) {
                Object.assign(context, JSON.parse(historyItem.getData()));
                setTimeout(() => {
                    window.scrollTo(0, historyItem.getPageYOffset());
                }, 10);
                resolve(true);
            }
            return resolve(false);
        });
    }

    static async saveCurrentState(context, route, pageYOffset, title, langSensitive = false) {
        return new Promise(resolve => {
            const historyItem = new ExplorerHistory(
                context.$options.name,
                JSON.stringify(context.$data),
                route,
                pageYOffset,
                title
            );

            if (langSensitive) {
                historyItem.setLangSensitivity(true);
            }

            context.$store.dispatch('explorerStore/pushComponent', historyItem);
            resolve(historyItem);

            /*let index = context.$store.getters['explorerStore/history'].findIndex(item => item.component === historyItem.getComponent());
            if (index > -1) {
                context.$store.dispatch('explorerStore/pushComponent', historyItem);
                resolve();
            } else {
                html2canvas(document.body, {
                    logging: false,
                    height: document.body.clientHeight - pageYOffset,
                    y: pageYOffset
                }).then(canvas => {
                    historyItem.setThumbnail(canvas.toDataURL("image/png"));
                    context.$store.dispatch('explorerStore/pushComponent', historyItem);
                    resolve();
                });
            }*/
        });
    }

    static clear(context) {
        return context.$store.dispatch('explorerStore/clear');
    }

    static remove(context) {
        return context.$store.dispatch('explorerStore/remove', context.$options.name);
    }

    static removeLangSensitives() {

    }
}

export default ExplorerHistory;
